import Navbar from '../../components/NavBar/NavBar';
import {useUser} from "../../utils/api";

const SharedRoute = ({ component: Component }) => {
    const { user } = useUser();

    return (
        user ? (
            <Navbar>
                <Component />
            </Navbar>
        ) : (
            <Component />
        )
    );
};

export default SharedRoute;
